import React, {useEffect} from 'react';
import ReportUtils from "../../../../../utils/report-utils.js";
import {navigateHook} from "../../../../../hooks/use-navigate.js";

const ReportContent = ({data, tableColumns}) => {
    const navigate = navigateHook();
    const rows = data ?? [];

    const getAddress = (element) => [
        element.schedule_factplace ?? "",
        element.schedule_factstreet ? `${element.schedule_factstreet}${element.schedule_factnumber ? `, ${element.schedule_factnumber}` : ""}` : "",
        element.schedule_factneighborhood ?? ""
    ].filter(Boolean).join(" - ");

    const columns = [
        {id: "dt_start", className: "w-[11%]", renderCell: element => element.dt_start ?? ""},
        {id: "dispatch_start", className: "w-[11%]", renderCell: element => element.dispatch_start ?? "Não realizado"},
        {
            id: "dispatch_numbercheckbook",
            className: "w-[6%]",
            renderCell: element => {
                const number = element.dispatch_id ? element.dispatch_numbercheckbook : "Sem talão";
                return element.dispatch_numbercheckbook ? <a onClick={() => navigate(`/despacho/dispatch/form/${element.dispatch_id}`, true)} className="report-link">{number}</a> : number;
            }
        },
        {id: "reason", className: "w-[12%]", renderCell: element => element.reason ?? ""},
        {id: "address", screenOnly: true, className: "w-[20%]", renderCell: getAddress},
        {id: "schedule_factplace", className: "w-[14%]", renderCell: element => element.schedule_factplace ?? ""},
        {id: "schedule_factneighborhood", className: "w-[12%]", renderCell: element => element.schedule_factneighborhood ?? ""},
        {id: "schedule_factstreet", className: "w-[14%]", renderCell: element => element.schedule_factstreet ?? ""},
        {id: "schedule_factnumber", className: "w-[8%]", renderCell: element => element.schedule_factnumber ?? ""},
        {id: "garrison_name", className: "w-[12%]", renderCell: element => <a onClick={() => navigate(`/despacho/garrison/form/${element.garrison_id}`, true)} className="report-link">{element.garrison_name}</a>},
        {id: "garrison_username", className: "w-[10%]", renderCell: element => element.garrison_username ?? ""},
        {id: "status", className: "w-[8%]", renderCell: element => element.status ?? ""},
        {id: "schedules_justification", className: "w-[10%]", renderCell: element => element.schedules_justification ?? ""}
    ];

    const isExportOnly = (column) => tableColumns?.[column.id]?.exportOnly === true;
    const isAddressDetail = (column) => ["schedule_factplace", "schedule_factneighborhood", "schedule_factstreet", "schedule_factnumber"].includes(column.id);
    const isAddressVisible = tableColumns?.address?.visible !== false;
    const isExportIgnored = (column) => column.screenOnly || (!isAddressVisible && isAddressDetail(column));
    const visibleColumns = columns.filter(column => !isExportOnly(column) && tableColumns?.[column.id]?.visible !== false);
    const renderColumns = columns.filter(column => isExportOnly(column) || tableColumns?.[column.id]?.visible !== false);

    useEffect(() => {
        if (!data) return;
        ReportUtils.createExportableTable(null, null, "Lista de atividades", "schedule-garrison-list-data");
    }, [data, tableColumns]);

    return (
        <>
            {visibleColumns.length === 0 && <div className="alert alert-info p-2 h6 text-center mt-[20px]!">Todas as colunas foram ocultadas.</div>}
            <table id="schedule-garrison-list-data" className={`table report-table ${visibleColumns.length === 0 ? "hidden" : ""}`}>
                <thead className="thead-background">
                    <tr className="bg-[#f6f6f6] text-left">
                        {renderColumns.map(column => <th key={column.id} className={`${column.className} ${isExportOnly(column) ? "hidden" : ""} ${isExportIgnored(column) ? "export-ignore" : ""}`}>{tableColumns?.[column.id]?.label ?? column.id}</th>)}
                    </tr>
                </thead>
                <tbody className="bg-white">
                    {rows.map((element, index) => (
                        <tr key={index} className="table-break-word">
                            {renderColumns.map(column => <td key={column.id} className={`${column.className} ${isExportOnly(column) ? "hidden" : ""} ${isExportIgnored(column) ? "export-ignore" : ""}`}>{column.renderCell(element)}</td>)}
                        </tr>
                    ))}
                </tbody>
            </table>

            <div id="chart-tables"/>
        </>
    );
};

export default ReportContent;